import { generateVerifierAndChallenge } from '@larlon/verifier-and-challenge/index';

export type PkcePair = {
  challenge: string;
  verifier: string;
};

export async function getPkcePair(): Promise<PkcePair> {
  return generateVerifierAndChallenge();
}
